import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import HierarchyActionsButton from './actions/HierarchyActionsButton';

const AssetHierarchyItem = ({ data, hierarchyActions, events }) => {
  const composeId = useCallback(key => `asset-hierarchy-${data.id}${key ? `-${key}` : ''}`, [data.id]);

  return events.onDisableHierarchy(data) ? (
    <TableRow id={composeId()}>
      <TableCell id={composeId('assetType')}>{data.assetType}</TableCell>
      <TableCell id={composeId('name')}>{data.name}</TableCell>
      <TableCell id={composeId('provider')}>{data.provider}</TableCell>
      <TableCell align='right'>
        <HierarchyActionsButton hierarchy={data} hierarchyActions={hierarchyActions} events={events} />
      </TableCell>
    </TableRow>
  ) : (
    <TableRow id={composeId()}>
      <TableCell id={composeId('assetType')}>{data.assetType}</TableCell>
      <TableCell id={composeId('name')}>{data.name}</TableCell>
      <TableCell id={composeId('provider')}>{data.provider}</TableCell>
      <TableCell align='right'>
        <HierarchyActionsButton hierarchy={data} hierarchyActions={hierarchyActions} events={events} />
      </TableCell>
    </TableRow>
  );
};

AssetHierarchyItem.propTypes = {
  data: PropTypes.object.isRequired,
  hierarchyActions: PropTypes.array.isRequired,
  events: PropTypes.object.isRequired
};

export default AssetHierarchyItem;
